export default {
  title: 'Searcher'
}
